import React, { useEffect, useState } from 'react';
import Web3 from 'web3';
import { toast } from 'react-hot-toast';
import { Dialog, Transition } from '@headlessui/react';;


const Home = () => {
    const [walletAddress, setWalletAddress] = useState(null);
    const [loading, setLoading] = useState(false);
    const [web3, setWeb3] = useState(null);
    const [publicWeb3, setPublicWeb3] = useState(null); 
    const [isNFTMinted, setIsNFTMinted] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [modalType, setModalType] = useState('nft'); // 'nft' or 'zor'
    const [zorAmount, setZorAmount] = useState('0');
    const [mintPrice, setMintPrice] = useState(null);
    const [userNFTs, setUserNFTs] = useState([]);
    const [loadingNFTs, setLoadingNFTs] = useState(false);
    const [showMyRugs, setShowMyRugs] = useState(false); 

    const contractAddress = '0xBa6C21b3217cf12f54627b10dF34532F32C7D9AB';
    const pentagonChainId = 3344; 
    const publicRpcUrl = 'https://rpc.pentagon.games'; 

    const contractABI = [
        {
            "inputs": [],
            "name": "erc20Mint",
            "outputs": [
                { "internalType": "bool", "name": "", "type": "bool" }
            ],
            "stateMutability": "payable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "mintingPaused",
            "outputs": [
                { "internalType": "bool", "name": "", "type": "bool" }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "MINTING_CAP",
            "outputs": [
                { "internalType": "uint256", "name": "", "type": "uint256" }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "nftContract",
            "outputs": [
                { "internalType": "contract Rug", "name": "", "type": "address" }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "zorToken",
            "outputs": [
                { "internalType": "contract IERC20", "name": "", "type": "address" }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "ERC20_PRICE_NFT",
            "outputs": [
                { "internalType": "uint256", "name": "", "type": "uint256" }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "anonymous": false,
            "inputs": [
                { "indexed": true, "internalType": "address", "name": "owner", "type": "address" },
                { "indexed": false, "internalType": "uint256", "name": "token", "type": "uint256" }
            ],
            "name": "Mint",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                { "indexed": true, "internalType": "address", "name": "owner", "type": "address" },
                { "indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256" }
            ],
            "name": "ZORRewarded",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                { "indexed": false, "internalType": "uint256", "name": "newPrice", "type": "uint256" }
            ],
            "name": "MintingPriceUpdated",
            "type": "event"
        }
    ];

    const decodeRevertReason = (error) => {
        if (error.data) {
            const hexString = error.data.startsWith('0x') ? error.data.slice(10) : error.data;
            try {
                return web3.utils.hexToAscii('0x' + hexString).replace(/\0/g, '');
            } catch {
                return error.data;
            }
        }
        return error.message || 'No revert reason provided';
    };

    const fetchMintPrice = async (web3Instance) => {
        try {
            const contract = new web3Instance.eth.Contract(contractABI, contractAddress);
            const price = await contract.methods.ERC20_PRICE_NFT().call();
            setMintPrice(web3Instance.utils.fromWei(price, 'ether')); 
            } catch (err) {
         
            toast.error('Failed to fetch minting price');
            setMintPrice(null);
        }
    };

    const connectWallet = async () => {
        try {
            if (!window.ethereum) {
                // Mobile deep link support
                if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
                    window.location.href = "https://metamask.app.link/dapp/rugpull.art";
                    return;
                }
                toast.error('MetaMask is not installed. Please install MetaMask to proceed.');
                return;
            }

            const web3Instance = new Web3(window.ethereum);
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            if (!accounts || accounts.length === 0) {
                toast.error('No accounts found.');
                return;
            }

            const currentChainId = await web3Instance.eth.getChainId();
            if (Number(currentChainId) === pentagonChainId) {
                setWalletAddress(accounts[0]);
                setWeb3(web3Instance);
                toast.success(`Connected: ${accounts[0].slice(0, 6)}...${accounts[0].slice(-4)}`);
                await fetchMintPrice(web3Instance);
                return;
            }

            try {
                await window.ethereum.request({
                    method: 'wallet_switchEthereumChain',
                    params: [{ chainId: `0x${pentagonChainId.toString(16)}` }],
                });
            } catch (switchError) {
                if (switchError.code === 4001) {
                    toast.error('User rejected switching to Pentagon Chain.');
                    return;
                } else if (switchError.code === 4902) {
                    try {
                        await window.ethereum.request({
                            method: 'wallet_addEthereumChain',
                            params: [
                                {
                                    chainId: `0x${pentagonChainId.toString(16)}`,
                                    chainName: 'Pentagon Chain',
                                    nativeCurrency: {
                                        name: 'PC',
                                        symbol: 'PC',
                                        decimals: 18,
                                    },
                                    rpcUrls: ['https://rpc.pentagon.games'],
                                    blockExplorerUrls: ['https://explorer.pentagon.games'],
                                },
                            ],
                        });
                    } catch (addError) {
                        if (addError.code === 4001) {
                            toast.error('User rejected adding Pentagon Chain.');
                            return;
                        } else if (addError.code === -32603 || addError.message.includes('already exists')) {
                            console.warn('Pentagon Chain already exists');
                        } else {
                            toast.error('Failed to add Pentagon Chain. Please add it manually');
                            return;
                        }
                    }
                } else {
                
                    toast.error('Failed to switch to Pentagon Chain. Please switch manually');
                    return;
                }
            }

            const chainId = await web3Instance.eth.getChainId();
            if (Number(chainId) !== pentagonChainId) {
                toast.error('Please switch to Pentagon Chain');
                return;
            }
            setWalletAddress(accounts[0]);
            setWeb3(web3Instance);
            toast.success(`Connected: ${accounts[0].slice(0, 6)}...${accounts[0].slice(-4)}`);
            await fetchMintPrice(web3Instance); 
        } catch (err) {
           
            toast.error(err.message || 'Failed to connect wallet. Please try again.');
        }
    };

    const handleMint = async () => {
        if (!walletAddress || !web3) {
            toast.error('Please connect wallet');
            return;
        }
        setLoading(true);
        setIsNFTMinted(false);

        const toastId = toast.loading('Processing....');

        try {
            const contract = new web3.eth.Contract(contractABI, contractAddress);

            let mintingPaused;
            try {
                mintingPaused = await contract.methods.mintingPaused().call();
                
            } catch (err) {
             
                throw new Error('Failed to check mintingPaused: ' + err.message);
            }
            if (mintingPaused) {
                toast.error('Minting is paused', { id: toastId });
                setLoading(false);
                return;
            }

            let mintingCap, nftContractAddr, itemsMintedCount;
            try {
                mintingCap = await contract.methods.MINTING_CAP().call();
                nftContractAddr = await contract.methods.nftContract().call();
                const nftContract = new web3.eth.Contract(
                    [
                        {
                            inputs: [],
                            name: 'itemsMintedCount',
                            outputs: [{ name: '', type: 'uint256' }],
                            stateMutability: 'view',
                            type: 'function'
                        }
                    ],
                    nftContractAddr
                );
                itemsMintedCount = await nftContract.methods.itemsMintedCount().call();
            } catch (err) {
                throw new Error('Failed to check minting cap or items minted: ' + err.message);
            }
            if (Number(itemsMintedCount) >= Number(mintingCap)) {
                toast.error('Minting cap reached', { id: toastId });
                setLoading(false);
                return;
            }

            let zorTokenAddr, zorBalance;
            try {
                zorTokenAddr = await contract.methods.zorToken().call();
                const zorContract = new web3.eth.Contract(
                    [
                        {
                            inputs: [{ name: 'account', type: 'address' }],
                            name: 'balanceOf',
                            outputs: [{ name: '', type: 'uint256' }],
                            stateMutability: 'view',
                            type: 'function'
                        }
                    ],
                    zorTokenAddr
                );
                zorBalance = await zorContract.methods.balanceOf(contractAddress).call();
            } catch (err) {
               
                throw new Error('Failed to check ZOR token balance: ' + err.message);
            }
            if (Number(zorBalance) < 100 * 10 ** 18) {
                toast.error('Contract has insufficient ZOR tokens', { id: toastId });
                setLoading(false);
                return;
            }

            let currentMintPrice;
            try {
                currentMintPrice = await contract.methods.ERC20_PRICE_NFT().call();
            } catch (err) {
              
                throw new Error('Failed to fetch minting price: ' + err.message);
            }

            let balance;
            try {
                balance = await web3.eth.getBalance(walletAddress);
            } catch (err) {
                throw new Error('Failed to fetch PC balance: ' + err.message);
            }
            if (Number(balance) < Number(currentMintPrice)) {
                toast.error(`Insufficient PC balance. Need at least ${web3.utils.fromWei(currentMintPrice, 'ether')} PC`, { id: toastId });
                setLoading(false);
                return;
            }

            toast.loading('Processing minting...', { id: toastId });

            let receipt;
            try {
                receipt = await contract.methods
                    .erc20Mint()
                    .send({
                        from: walletAddress,
                        value: currentMintPrice,
                        gas: 500000,
                        gasPrice: await web3.eth.getGasPrice(),
                    })
                    .on('transactionHash', (hash) => {
                    })
                    .on('confirmation', (confNumber, receipt) => {
                    });
            
            } catch (err) {
                
                const revertReason = decodeRevertReason(err);
               
                throw new Error(`Failed to execute erc20Mint: ${revertReason}`);
            }

            const mintEvent = receipt.events?.Mint;
            const zorEvent = receipt.events?.ZORRewarded;
            toast.dismiss(toastId);

            if (mintEvent) {
                setIsNFTMinted(true);
                setModalType('nft');
                setModalMessage('You pulled a legendary Rug NFT!');
                setIsModalOpen(true);
            } else if (zorEvent && zorEvent.returnValues && zorEvent.returnValues.amount !== undefined) {
                const amount = web3.utils.fromWei(zorEvent.returnValues.amount, 'ether');
                setZorAmount(amount);
                setModalType('zor');
                setModalMessage(`You received ${amount} ZOR tokens`);
                setIsModalOpen(true);
            } else {
                setZorAmount('100');
                setModalType('zor');
                setModalMessage('You received 100 ZOR tokens');
                setIsModalOpen(true);
            }

            setLoading(false);
        } catch (error) {
          
            let errorMessage = 'Operation failed';
            if (error.message.includes('User denied')) {
                errorMessage = 'Transaction cancelled';
            } else if (error.message.includes('Minting paused')) {
                errorMessage = 'Minting is paused';
            } else if (error.message.includes('Minting cap reached')) {
                errorMessage = 'Minting cap reached';
            } else if (error.message.includes('Insufficient PC balance')) {
                errorMessage = 'Insufficient PC balance for minting';
            } else if (error.message.includes('Insufficient ZOR tokens')) {
                errorMessage = 'Contract has insufficient ZOR tokens';
            } else if (error.message.includes('revert')) {
                errorMessage = 'Transaction reverted: ' + (error.message.split('revert')[1]?.trim() || decodeRevertReason(error));
            } else if (error.message.includes('Internal JSON-RPC error')) {
                errorMessage = 'RPC error: Please check your network connection or try a different RPC URL.';
            } else {
                errorMessage = error.message || 'Unknown error occurred';
            }
            toast.error(errorMessage, { id: toastId });
            setLoading(false);
        }
    };

    const fetchUserNFTs = async () => {
        if (!walletAddress) {
            toast.error('Please connect your wallet first');
            return;
        }
        
        setLoadingNFTs(true);
        try {
            const response = await fetch(`https://api.rugpull.art/transactions/${walletAddress}`);
            if (!response.ok) {
                throw new Error('Failed to fetch NFTs');
            }
            const transactions = await response.json();
            
            // Filter only successful mints (transactions with nft_token_id)
            const nfts = transactions
                .filter(tx => tx.nft_token_id && tx.event_type === 'Mint')
                .map(tx => ({
                    tokenId: tx.nft_token_id,
                    transactionHash: tx.tx_hash,
                    timestamp: tx.timestamp,
                }));
            
            // Fetch metadata for each NFT
            const nftDetails = await Promise.all(
                nfts.map(async (nft) => {
                    try {
                        const metadataResponse = await fetch(`https://api.rugpull.art/${nft.tokenId}.json`);
                        if (metadataResponse.ok) {
                            const metadata = await metadataResponse.json();
                            return {
                                ...nft,
                                ...metadata
                            };
                        }
                    } catch (err) {
                        console.error(`Failed to fetch metadata for token ${nft.tokenId}:`, err);
                    }
                    return nft;
                })
            );
            
            setUserNFTs(nftDetails);
            setShowMyRugs(true);
        } catch (error) {
            console.error('Error fetching NFTs:', error);
            toast.error('Failed to load your rugs. Please try again.');
        } finally {
            setLoadingNFTs(false);
        }
    };

  
    useEffect(() => {
        const initializePublicWeb3 = async () => {
            try {
              
                const publicWeb3Instance = new Web3(publicRpcUrl);
                setPublicWeb3(publicWeb3Instance);
                await fetchMintPrice(publicWeb3Instance); 
            } catch (err) {
             
                toast.error('Failed to connect to network or fetch minting price');
            }
        };

        const checkWalletConnection = async () => {
            try {
                if (!window.ethereum) {
                    return;
                }
                const web3Instance = new Web3(window.ethereum);
                const accounts = await web3Instance.eth.getAccounts();
                const chainId = await web3Instance.eth.getChainId();
                const pentagonChainIdHex = `0x${pentagonChainId.toString(16)}`;
                if (Number(chainId) !== pentagonChainId) {
                    try {
                        await window.ethereum.request({
                            method: 'wallet_switchEthereumChain',
                            params: [{ chainId: pentagonChainIdHex }],
                        });
                   
                    } catch (switchError) {
                      
                    }
                }

                if (accounts.length > 0) {
                    setWalletAddress(accounts[0]);
                    setWeb3(web3Instance);
                    await fetchMintPrice(web3Instance); 
                }
            } catch (err) {
            
            }
        };

        const handleCopy = (e) => {
            e.preventDefault();
        };

        document.addEventListener('copy', handleCopy);
        initializePublicWeb3(); 
        checkWalletConnection();

        return () => {
            document.removeEventListener('copy', handleCopy);
        };
    }, []);

    return (
        <div className="min-h-screen bg-gradient-to-b from-[#11002C] to-[#1F002D] text-white px-6 py-10 font-sans select-none">
            <div className="max-w-6xl mx-auto text-left">
                <p className="uppercase tracking-widest text-m text-purple-300">
                    The Official Rug Pull Collection
                </p>
                <div className="flex flex-col md:flex-row items-center justify-between ">
                    <div className="flex-1 text-center md:text-left">
                        <h1 className="text-5xl md:text-6xl font-extrabold leading-tight text-yellow-300">
                            Spin the Wheel.<br /> Dodge the Rug.
                        </h1>
                        <p className="mt-4 text-lg text-gray-300">
                            10,000 AI-Generated Rug Art, One destiny: Will you pull or be pulled?
                        </p>
                        <div className="mt-6 flex justify-center md:justify-start gap-4 flex-wrap items-center">
                            <button
                                onClick={handleMint}
                                className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-5 rounded-full shadow-xl cursor-pointer"
                                disabled={loading}
                                >
                                  {loading ? 'Processing...' : `${mintPrice ? mintPrice : 'Loading...'} $PC - For a Chance to Pull a Rug`}

                            </button>
                            <button
                                onClick={() =>
                                    document.getElementById('rugLoreSection')?.scrollIntoView({ behavior: 'smooth' })
                                }
                                className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-5 rounded-full shadow-xl cursor-pointer"
                            >
                                View RugLore
                            </button>
                            {walletAddress && (
                                <button
                                    onClick={fetchUserNFTs}
                                    disabled={loadingNFTs}
                                    className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-5 rounded-full shadow-xl cursor-pointer disabled:opacity-50"
                                >
                                    {loadingNFTs ? 'Loading...' : '🖼️ View My Rugs'}
                                </button>
                            )}
                        </div>
                        <p className="mt-3 text-sm text-purple-300 italic">
                            *Pay with {" "}
                            <span className="font-semibold text-white">PC</span> token
                            
                        </p>
                    </div>
                    <div className="flex-1 max-w-sm md:max-w-md lg:max-w-lg flex flex-col items-center">
                        <div className="mb-6 text-center w-full">
                            {walletAddress ? (
                                <div className="text-green-400 font-semibold text-sm">
                                    Wallet Connected: {walletAddress.slice(0, 6)}...{walletAddress.slice(-4)}
                                </div>
                            ) : (
                                <button
                                    onClick={connectWallet}
                                    className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-5 rounded-full shadow-xl cursor-pointer"
                                >
                                    🦊 Connect Wallet & Pull Now
                                </button>
                            )}
                        </div>
                        <img
                            src="/images/spin-wheel.png"
                            alt="Spin Wheel"
                            className="w-full h-auto max-h-[400px] object-contain"
                        />
                    </div>
                </div>

                {/* My Rugs Gallery */}
                {showMyRugs && (
                    <div className="mt-14 bg-gradient-to-r from-blue-950 via-blue-900 to-blue-950 p-8 rounded-2xl shadow-2xl border border-blue-700">
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-3xl font-bold text-white">🖼️ My Rugs Collection</h2>
                            <button
                                onClick={() => setShowMyRugs(false)}
                                className="text-gray-400 hover:text-white transition"
                            >
                                ✕ Close
                            </button>
                        </div>
                        
                        {userNFTs.length === 0 ? (
                            <div className="text-center py-12">
                                <div className="text-6xl mb-4">🎲</div>
                                <p className="text-xl text-gray-300 mb-4">No rugs yet!</p>
                                <p className="text-gray-400 mb-4">Pull a rug to start your collection</p>
                                <div className="bg-blue-900/50 border border-blue-600 rounded-lg p-4 max-w-md mx-auto">
                                    <p className="text-sm text-blue-200">
                                        ⏱️ Just minted? Your rug will appear here <span className="font-bold">within 10 seconds</span>!
                                    </p>
                                    <button
                                        onClick={fetchUserNFTs}
                                        disabled={loadingNFTs}
                                        className="mt-3 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold py-2 px-4 rounded-full transition disabled:opacity-50"
                                    >
                                        {loadingNFTs ? 'Refreshing...' : '🔄 Refresh Now'}
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="flex justify-between items-center mb-6">
                                    <p className="text-gray-300">You own <span className="font-bold text-blue-400">{userNFTs.length}</span> rug{userNFTs.length !== 1 ? 's' : ''}</p>
                                    <button
                                        onClick={fetchUserNFTs}
                                        disabled={loadingNFTs}
                                        className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold py-2 px-4 rounded-full transition disabled:opacity-50"
                                    >
                                        {loadingNFTs ? 'Refreshing...' : '🔄 Refresh'}
                                    </button>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                    {userNFTs.map((nft, idx) => (
                                        <div
                                            key={idx}
                                            className="bg-gray-900 rounded-xl overflow-hidden shadow-lg hover:shadow-blue-500/50 transition duration-300 border border-gray-700"
                                        >
                                            <div className="relative aspect-square">
                                                <img
                                                    src={nft.image || '/images/placeholder-rug.png'}
                                                    alt={nft.name || `Rug #${nft.tokenId}`}
                                                    className="w-full h-full object-cover"
                                                    onError={(e) => { e.target.src = '/images/placeholder-rug.png'; }}
                                                />
                                                {nft.attributes?.find(attr => attr.trait_type === 'Rarity') && (
                                                    <div className="absolute top-2 right-2 bg-purple-600 text-white text-xs font-bold px-3 py-1 rounded-full">
                                                        {nft.attributes.find(attr => attr.trait_type === 'Rarity').value}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="p-4">
                                                <h3 className="text-lg font-bold text-white mb-2">
                                                    {nft.name || `Rug #${nft.tokenId}`}
                                                </h3>
                                                {nft.description && (
                                                    <p className="text-sm text-gray-400 mb-3">{nft.description}</p>
                                                )}
                                                {nft.attributes && nft.attributes.length > 0 && (
                                                    <div className="space-y-1">
                                                        {nft.attributes.slice(0, 4).map((attr, i) => (
                                                            <div key={i} className="flex justify-between text-xs">
                                                                <span className="text-gray-500">{attr.trait_type}:</span>
                                                                <span className="text-gray-300 font-semibold">{attr.value}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                                <div className="mt-4 flex gap-2">
                                                    <a
                                                        href={`https://explorer.pentagon.games/tx/${nft.transactionHash}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="flex-1 bg-blue-600 hover:bg-blue-700 text-white text-center text-xs font-semibold py-2 rounded transition"
                                                    >
                                                        View on Explorer
                                                    </a>
                                                    <a
                                                        href={`https://market.pentagon.games`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="flex-1 bg-purple-600 hover:bg-purple-700 text-white text-center text-xs font-semibold py-2 rounded transition"
                                                    >
                                                        Trade
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                )}

                <div className="mt-14">
                    <h2 className="text-2xl font-bold mb-4 text-white">Explore the Chaos of Thread & Fate</h2>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 justify-items-center items-start">
                        {[
                            { name: 'Azure Wave Majesty', image: '/images/Azure-Wave-Majesty.png' },
                            { name: 'Lavender Lunar Lattice', image: '/images/Lavender-Lunar-Lattice.png' },
                            { name: 'Sapphire Tribal Odyssey', image: '/images/Sapphire-Tribal-Odyssey.png' },
                            { name: 'Cyan Circuit Majesty', image: '/images/Cyan-Circuit-Majesty.png' },
                        ].map((rug, idx) => (
                            <div
                                key={idx}
                                className="relative w-full max-w-xs h-48 bg-gray-900 rounded-lg shadow-md overflow-hidden flex flex-col"
                            >
                                <img
                                    src={rug.image}
                                    alt={rug.name}
                                    className="w-full h-full object-fill object-center"
                                />
                                <div className="absolute bottom-0 w-full bg-black bg-opacity-80 text-white text-center py-1 text-sm">
                                    {rug.name}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="mt-14 grid md:grid-cols-2 gap-10 text-left">
                    <div>
                        <h3 className="text-xl font-semibold mb-4">🔁 How It Works</h3>
                        <ol className="list-decimal ml-6 space-y-4 text-sm">
                            <li>
                                <strong className="text-orange-400">Pay $PC Gas Token</strong>
                                <br />
                                Connect to Pentagon Chain and mint with $PC.
                                <br />
                                No $PC? Try the <a href="https://faucet.pentagon.games" target="_blank" rel="noopener noreferrer" className="font-semibold text-blue-300 underline">faucet</a>.
                            </li>
                            <li>
                                <strong className="text-orange-400">Pull the Thread</strong>
                                <br />
                                Spin the gacha to pull a rug. You might win a legendary Rug NFT…
                                <br />
                                or a handful of $ZOR tokens.
                            </li>
                            <li>
                                <strong className="text-orange-400">Flex or Regret</strong>
                                <br />
                                Your Rug is minted on-chain. Keep it, sell at the {" "}
                                <a href="https://market.pentagon.games" target="_blank" rel="noopener noreferrer" className="font-semibold text-blue-300 underline">market</a>,
                                or cry in the {""}
                                <a href="Discord.gg/pentagongamesxp" target="_blank" rel="noopener noreferrer" className="font-semibold text-blue-300 underline">Discord</a>.
                            </li>
                        </ol>
                    </div>
                    <div className="bg-purple-800 p-6 rounded-xl text-sm shadow-lg w-full md:w-5/6">
                        <h4 className="font-bold text-lg text-yellow-300 mb-2">🎲 Rarity System</h4>
                        <ul className="space-y-1">
                            <li>💠 <span className="text-yellow-200">Mythic Rugs</span> – 5%</li>
                            <li>🔷 <span className="text-blue-300">Epic Threads</span> – 10%</li>
                            <li>🧶 <span className="text-white">Common Rugs</span> – 18%</li>
                            <li>❌ No Rug / ZOR – 67%</li>
                        </ul>
                        <p className="text-xs mt-2 text-red-300 italic">Got ZORed?. Better luck next time.</p>
                    </div>
                </div>
                <div className="mt-16 grid md:grid-cols-2 gap-10 text-left">
                    <div className="text-left">
                        <div className=" p-6 bg-gradient-to-r from-purple-900 to-purple-800 rounded-xl shadow-lg border border-purple-600">
                            <h3 className="text-xl font-bold text-yellow-300 mb-4">
                                What Can You Do with Your NFT?
                            </h3>
                            <ul className="list-disc ml-6 space-y-2 text-sm text-gray-200">
                                <li>
                                    Download the <span className="font-semibold text-blue-300">PEN Wallet app</span> to view your latest pull
                                </li>
                                <li>
                                    Visit your personal <span className="font-semibold text-blue-300">Spatial (dollhouse){" "}</span>
                                    to display and showcase your new rug
                                </li>
                                <li>
                                    Visit {' '}
                                    <a
                                        href="https://market.pentagon.games"
                                        className="text-blue-300 hover:text-blue-100 underline transition duration-200"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        market.pentagon.games
                                    </a>{' '}
                                    to trade or swap your rug for a different one
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className='ml-4'>
                        <h4 className="font-bold text-md mb-4">🧙 Meet the Ruglords</h4>
                        <div className="flex gap-6 items-center">
                            {[
                                { name: 'Ruglord Noodle', image: '/images/ruglord-noodle.png' },
                                { name: 'Threadmaster Em', image: '/images/threadmaster-em.png' },
                                { name: 'The ZOR Professor', image: '/images/zor-oracle.png' },
                            ].map((character, i) => (
                                <div key={i} className="flex flex-col items-center text-xs">
                                    <img
                                        src={character.image}
                                        alt={character.name}
                                        className="w-14 h-14 rounded-full mb-1 shadow-inner object-cover"
                                    />
                                    <span>{character.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Pentagon Chain Official Section */}
                <div className="mt-20 bg-gradient-to-r from-indigo-950 via-indigo-900 to-indigo-950 p-8 rounded-2xl shadow-2xl border border-indigo-700">
                    <div className="text-center mb-6">
                        <div className="inline-block bg-green-500 text-white px-4 py-2 rounded-full text-sm font-bold mb-4">
                            ✅ Approved by Pentagon Games
                        </div>
                        <h2 className="text-3xl font-extrabold text-white mb-4">
                            Part of the Pentagon Chain Ecosystem
                        </h2>
                        <p className="text-gray-300 text-base mb-6 max-w-3xl mx-auto">
                            Rugpull.art is an official collection on <a href="https://pentagonchain.com" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline font-semibold">Pentagon Chain</a>, 
                            the blockchain powering the future of Web3 gaming and NFT experiences. These rugs are just the beginning of something bigger.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 gap-8 text-left">
                        <div className="bg-indigo-800 p-6 rounded-xl">
                            <h3 className="text-xl font-bold text-yellow-300 mb-4">🎮 EtherFantasy Integration (Coming Soon)</h3>
                            <p className="text-gray-300 text-sm mb-4">
                                Your rug isn't just art — it's a piece of the <span className="font-semibold text-purple-200">EtherFantasy</span> multiverse experience. 
                                Soon, you'll be able to:
                            </p>
                            <ul className="text-sm text-gray-300 space-y-2">
                                <li>🏠 <span className="font-semibold">Display in your Spatial</span> — Personalize your 3D space</li>
                                <li>🎭 <span className="font-semibold">Cross-game utility</span> — Use across Pentagon ecosystem</li>
                                <li>🔮 <span className="font-semibold">Quest rewards</span> — Rare rugs unlock special benefits</li>
                            </ul>
                        </div>

                        <div className="bg-indigo-800 p-6 rounded-xl">
                            <h3 className="text-xl font-bold text-yellow-300 mb-4">📊 Collection Status</h3>
                            <p className="text-gray-300 text-sm mb-4">
                                <span className="font-bold text-white text-lg">Phase 1:</span> 1,000 unique rugs designed and ready<br/>
                                <span className="font-bold text-white text-lg">Total Collection:</span> 10,000 rugs planned
                            </p>
                            <p className="text-sm text-gray-300">
                                The remaining 9,000 designs will be revealed after the first 1,000 are minted. 
                                Early collectors get first access to the rarest patterns.
                            </p>
                        </div>
                    </div>

                    <div className="mt-8 text-center">
                        <p className="text-gray-400 text-sm mb-4">Join the Pentagon Games community:</p>
                        <div className="flex justify-center gap-4 flex-wrap">
                            <a href="https://t.me/PentagonGamesxp" target="_blank" rel="noopener noreferrer" className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-6 rounded-full transition duration-200">
                                📱 Telegram
                            </a>
                            <a href="https://twitter.com/PentagonGamesxp" target="_blank" rel="noopener noreferrer" className="bg-blue-400 hover:bg-blue-500 text-white font-semibold py-2 px-6 rounded-full transition duration-200">
                                🐦 Twitter
                            </a>
                            <a href="https://discord.gg/pentagongamesxp" target="_blank" rel="noopener noreferrer" className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-6 rounded-full transition duration-200">
                                💬 Discord
                            </a>
                        </div>
                    </div>
                </div>

                <div
                    id="rugLoreSection"
                    className="mt-20 bg-gradient-to-r from-purple-950 via-purple-900 to-purple-950 p-8 rounded-2xl shadow-2xl border border-purple-700 relative">
                    <h2 className="text-3xl font-extrabold text-yellow-300 mb-6 flex items-center gap-3 relative">
                        <span className="text-4xl">📖</span> The Rugpull Art Collection
                        <span className="absolute bottom-0 left-0 w-48 h-1 bg-gradient-to-r from-yellow-300 to-transparent rounded-full" />
                    </h2>
                    <p className="text-gray-300 text-sm leading-relaxed mb-4 text-shadow-sm">
                        Is it just a rug or your <span className="font-semibold text-purple-200">key to something greater</span>? Across the digital world, there exists a set of mysterious artifacts — 10,000 unique, AI-woven rugs known only as the Rugpull Collection. Each one is a masterpiece of texture, color, and hidden design — but beneath the surface lies something more.
                    </p>
                    <p className="text-gray-300 text-sm leading-relaxed mb-4 text-shadow-sm">
                        These aren't just decorative pieces. Each rug is infused with personality — some calming, some vibrant, some <span className="italic text-purple-200">practically alive</span>. When placed inside your personal space, they don't just sit… they resonate. They shape the energy of the room, spark inspiration, and sometimes, unlock something deeper.
                    </p>
                    <p className="text-gray-300 text-sm leading-relaxed mb-4 text-shadow-sm">
                        It's said that the most attuned rugs act like gateways — quietly syncing with the space they inhabit, subtly enhancing it, and in rare cases, revealing pathways to <span className="font-semibold with text-purple-200">undiscovered dimensions of your creativity</span>.
                    </p>
                    <p className="text-gray-300 font-bold text-sm leading-relaxed mb-4 text-shadow-sm">
                        And yes, every rug is a pull — a chance. A moment of wonder.
                    </p>
                    <p className="text-gray-300 text-sm leading-relaxed mb-4 text-shadow-sm">
                        Some users receive timeless designs. Others discover glowing, interactive threads. And a lucky few? They say their rug <span className="italic text-purple-200">moved them</span>.
                    </p>
                    <ul className="ml-6 text-gray-300 text-sm leading-relaxed mb-6">
                        <li className="flex items-center gap-2">
                            <span className="text-purple-200">🧵</span> Pull a rug
                        </li>
                        <li className="flex items-center gap-2">
                            <span className="text-purple-200">🧵</span> Place it in your spatial
                        </li>
                        <li className="flex items-center gap-2">
                            <span className="text-purple-200">🧵</span> And see where it takes you.
                        </li>
                    </ul>
                    <p className="text-base font-bold text-purple-200 mt-3 italic">
                        🧵 What the community is saying:
                    </p>
                    <div className="mt-6 grid md:grid-cols-3 gap-6 text-center">
                        {[
                            {
                                title: '“I thought it was just a meme — now it’s the centerpiece of my room. Digital feng shui.”',
                                desc: '— @ethterior',
                            },
                            {
                                title: '“It just fits. The pattern, the vibe — like it was made for my space.”',
                                desc: '— @mintmancer',
                            },
                            {
                                title: '“My third rug looks ancient — dropped it in my spatial and it feels like a portal.”',
                                desc: '— @glitchcarpet',
                            },
                        ].map((item, i) => (
                            <div
                                key={i}
                                className="bg-purple-800 p-5 rounded-xl shadow-md hover:shadow-purple-700 transition duration-300 ease-in-out border border-purple-600 relative"
                            >
                                <span className="absolute top-2 left-2 text-purple-200">💬</span>
                                <h4 className="text-xs text-white mb-2 mt-4 italic">{item.title}</h4>
                                <p className="text-[10px] font-bold text-purple-200">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                    <div className="my-4 flex justify-center">
                        <div className="w-32 h-1 bg-gradient-to-r from-transparent via-purple-200 to-transparent rounded-full" />
                    </div>
                    <p className="text-gray-300 text-sm leading-relaxed text-shadow-sm">
                        Spin the gacha to pull a rug. You might reveal a legendary rug NFT or walk away with a handful of curious ZOR tokens — mysterious, unpredictable, and possibly useful in the future.
                    </p>
                </div>
            </div>

            <Transition appear show={isModalOpen} as={React.Fragment}>
                <Dialog as="div" className="fixed inset-0 z-10 flex items-center justify-center bg-black bg-opacity-70" onClose={() => setIsModalOpen(false)}>
                    <Transition.Child
                        as={React.Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        {modalType === 'nft' ? (
                            <Dialog.Panel className="transform overflow-hidden rounded-2xl bg-gradient-to-br from-purple-900 to-purple-800 p-8 text-center shadow-2xl transition-all border-4 border-yellow-300 max-w-md w-full">
                                <div className="text-6xl mb-4">🎉</div>
                                <Dialog.Title as="h3" className="text-3xl font-extrabold text-yellow-300 mb-4">
                                    Congratulations!
                                </Dialog.Title>
                                <p className="text-xl text-white mb-4">{modalMessage}</p>
                                <div className="bg-purple-800/50 border border-purple-500 rounded-lg p-4 mb-6">
                                    <p className="text-sm text-purple-200 mb-2">
                                        ⏱️ <span className="font-semibold">Your rug will appear in "My Rugs" within 10 seconds!</span>
                                    </p>
                                    <p className="text-xs text-gray-400">
                                        Our sync job updates every 5 seconds. Refresh to see your new rug!
                                    </p>
                                </div>
                                <p className="text-sm text-gray-300 mb-6">
                                    View it in your <span className="font-semibold text-purple-200">PEN Wallet</span> or display it in your <span className="font-semibold text-purple-200">Spatial</span>!
                                </p>
                                <button
                                    type="button"
                                    className="w-full bg-yellow-400 hover:bg-yellow-500 text-purple-900 font-bold py-3 px-6 rounded-full text-lg transition duration-200"
                                    onClick={() => setIsModalOpen(false)}
                                >
                                    Awesome! ✨
                                </button>
                            </Dialog.Panel>
                        ) : (
                            <Dialog.Panel className="transform overflow-hidden rounded-2xl bg-gradient-to-br from-red-950 to-gray-900 p-8 text-center shadow-2xl transition-all border-4 border-red-500 max-w-lg w-full">
                                <div className="text-7xl mb-4">🪤</div>
                                <Dialog.Title as="h3" className="text-5xl font-extrabold text-red-500 mb-2">
                                    YOU GOT PULLED!
                                </Dialog.Title>
                                <p className="text-xl text-gray-400 mb-2 italic">Better luck next time...</p>
                                <p className="text-lg text-yellow-400 mb-4 font-semibold">🎲 ~1 in 3 chance to pull a rug!</p>
                                <div className="bg-gradient-to-r from-yellow-400 to-orange-500 text-gray-900 font-bold py-2 px-4 rounded-full text-lg mb-6">
                                    {modalMessage}
                                </div>
                                <div className="bg-gray-800 rounded-xl p-6 mb-6 border-2 border-yellow-500 relative overflow-hidden">
                                    <div className="absolute top-0 right-0 text-6xl opacity-10 transform rotate-12">🪤</div>
                                    <p className="text-xl text-yellow-400 mb-4 font-bold">🎰 Need more PC to try again?</p>
                                    <ul className="text-left text-base text-gray-300 space-y-3 relative z-10">
                                        <li className="flex items-start gap-3">
                                            <span className="text-2xl">🌉</span>
                                            <div>
                                                <span className="font-semibold text-white">Bridge to Pentagon Chain</span>
                                                <br/>
                                                <span className="text-sm">Get PC at <a href="https://bridge.pentagon.games" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline font-semibold">bridge.pentagon.games</a> — bridge USDC/ETH from any chain!</span>
                                            </div>
                                        </li>
                                        <li className="flex items-start gap-3">
                                            <span className="text-2xl">🎮</span>
                                            <div>
                                                <span className="font-semibold text-white">Get involved & earn free PC</span>
                                                <br/>
                                                <span className="text-sm">Join <a href="https://pentagon.games" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline font-semibold">Pentagon.games</a> community — complete quests for free tokens!</span>
                                            </div>
                                        </li>
                                        <li className="flex items-start gap-3">
                                            <span className="text-2xl">🔄</span>
                                            <div>
                                                <span className="font-semibold text-white">Swap your ZOR for PC</span>
                                                <br/>
                                                <span className="text-sm">Head to <a href="https://pentaswap.io" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline font-semibold">PentaSwap.io</a> and trade up!</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="flex gap-3">
                                    <button
                                        type="button"
                                        className="flex-1 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-bold py-4 px-4 rounded-full text-base transition duration-200 shadow-lg"
                                        onClick={() => window.open('https://pentaswap.io', '_blank')}
                                    >
                                        💱 Swap ZOR
                                    </button>
                                    <button
                                        type="button"
                                        className="flex-1 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-bold py-4 px-4 rounded-full text-base transition duration-200 shadow-lg"
                                        onClick={() => setIsModalOpen(false)}
                                    >
                                        🎲 Try Again!
                                    </button>
                                </div>
                                <p className="text-xs text-gray-500 mt-4 italic">The rug pulled you this time... but rugs are still out there! 🪤</p>
                            </Dialog.Panel>
                        )}
                    </Transition.Child>
                </Dialog>
            </Transition>
        </div>
    );
};

export default Home;